import smartsheetLogo from '../../public/smartsheetLogo.png';
import wrikeLogo from '../../public/wrikeLogo.png';
import { DocumentSource, type RemoteTaskManagerProvider } from '@prisma/client';
import { type StaticImageData } from 'next/image';
import googleDocLogo from '../../public/doc.png';
import googleSlideLogo from '../../public/slide.png';
import googleSheetLogo from '../../public/gsheet.png';
import wordLogo from '../../public/word_logo.png';
import pdfLogo from '../../public/pdf_logo.png';
import imageLogo from '../../public/image_logo.png';
import videoLogo from '../../public/video_logo.png';
import jiraLogo from '../../public/jira-logo.webp';
import asanaLogo from '../../public/asana-logo.png';
import figmaLogo from '../../public/figma.png';

export const getProviderLogo = (provider: RemoteTaskManagerProvider): StaticImageData => {
  const providerLogoMap: Record<RemoteTaskManagerProvider, StaticImageData> = {
    JIRA: jiraLogo,
    SMARTSHEET: smartsheetLogo,
    ASANA: asanaLogo,
    WRIKE: wrikeLogo,
  };

  return providerLogoMap[provider];
};

export const getDocumentSourceLogo = (type?: DocumentSource): string => {
  if (!type) return '';
  const imageSrc = {
    [DocumentSource.TEXT]: wordLogo.src,
    [DocumentSource.GOOGLE_DOC]: googleDocLogo.src,
    [DocumentSource.GOOGLE_SHEET]: googleSheetLogo.src,
    [DocumentSource.GOOGLE_SLIDE]: googleSlideLogo.src,
    [DocumentSource.MS_WORD]: wordLogo.src,
    [DocumentSource.PDF]: pdfLogo.src,
    [DocumentSource.IMAGE]: imageLogo.src,
    [DocumentSource.VIDEO]: videoLogo.src,
    [DocumentSource.FIGMA]: figmaLogo.src,
  };
  return imageSrc[type as keyof typeof imageSrc] ?? '';
};
